import { FGCheckbox, FGIcons, FGStack, FGStackItem, FGTile, FGTypography } from '@fg/design-system';
import GQFlag from 'components/GQFlag';

import React from 'react';
type Props = {
    id: number;
    name: string;
    isSelected: boolean;
    onClick: (id: number) => void;
    isMultiSelect: boolean;
}
const NewCountryPickerCountryListItem = React.memo((props: Props) => {
    const { id, name, isSelected, onClick, isMultiSelect } = props;

    return (
        <FGTile
            data-testid="country-option"
            appearance="secondary"
            padding="small"
            style={{ width: '100%' }}
            onClick={() => onClick(id)}>
            <FGStack
                gap={0}
                alignItems="center"
                justifyContent="space-between"
                style={{
                    width: '100%',
                    pointerEvents: 'none',
                }}>
                <FGStackItem>
                    <FGStack alignItems="center" gap={8}>
                        {isMultiSelect && <FGCheckbox isChecked={isSelected} />}
                        <GQFlag countryId={id} style={{ margin: 0 }} />
                        <FGTypography tag="label" variant="label2">
                            {name}
                        </FGTypography>
                    </FGStack>
                </FGStackItem>
                <FGStackItem>
                    {!isMultiSelect && isSelected && <FGIcons icon="Check2" />}
                </FGStackItem>
            </FGStack>
        </FGTile>
    );
});

export default NewCountryPickerCountryListItem;